<template>
  <Container type="card-full" drankColor>
    <div class="main">
    <el-tabs v-model="activeName" type="card" :before-leave="leaveTab">
      <el-tab-pane label="按预审项对比检查" name="aysdb">
        <ex-pqc-check-index :activeName="activeName"></ex-pqc-check-index>
      </el-tab-pane>
      <el-tab-pane lazy label="按供应商逐一检查" name="agys">
        <ex-pqc-check-com-index :activeName="activeName"></ex-pqc-check-com-index>
      </el-tab-pane>
      <el-tab-pane lazy label="初审汇总" name="cshz" v-if="+this.$store.getters.expertLoginUser.pexpertroletype === 1">
        <ex-pqc-check-sum :activeName="activeName"></ex-pqc-check-sum>
      </el-tab-pane>
      <el-tab-pane lazy label="申请修改" name="sqgf">
        <ex-apply-for-modification :activeName="activeName" :pexchangetype="1"></ex-apply-for-modification>
      </el-tab-pane>
    </el-tabs>
    </div>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import ExPqcCheckIndex from './exPqcCheckIndex'
  import ExPqcCheckComIndex from './exPqcCheckComIndex'
  import exPqcCheckSum from './exPqcCheckSum'
  import exApplyForModification from './exApplyForModification'
  import utils from '../../assets/js/utils'
  import dayjs from 'dayjs'
  export default {
    name: 'exPqcCheckTab',
    data () {
      return {
        activeName: 'aysdb',
        pexpertInfo:{},
        project: {}
      }
    },
    async created () {
      await this.getModel()
    },
    async activated() {
      await this.getModel()
      this.getPexertInfo()
    },
    mounted () {
    },
    watch: {
    },
    components: {ExPqcCheckIndex, ExPqcCheckComIndex,exPqcCheckSum,exApplyForModification},
    methods: {
      async initPqcitemcheck () {
        await request({
          url: 'expert/insertPqcitemcheck',
          method: "post",
          data: {
            projectid: this.$store.getters.expertLoginUser.pexpertprojectid,
            pexpertid: this.$store.getters.expertLoginUser.pexpertid
          }
        })
      },
      leaveTab(activeName, oldActiveName) {
      },
      async getModel () {
        let res = await request({
          method: 'get',
          url: 'expert/findProjectById',
          params: {projectid: this.$store.getters.expertLoginUser.pexpertprojectid}
        })
        this.project = res
      },
      async getPexertInfo () {
        let res = await request({
          method: 'get',
          url: 'expert/getPexertInfo',
          params: {pexpertid: this.$store.getters.expertLoginUser.pexpertid}
        })
        this.pexpertInfo = res
        if(this.pexpertInfo.pexpertmobile == null){
            this.$message.warning('请先填写评审人资料')
            this.$router.push({name: 'pExpertIndex', params: {}})
            return
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .main {
    background-color: #fff;
    padding: 10px;
  }
</style>
